module.exports = "/assets/data/12f43e6ea7c91eb8770c7c566d1fb748-KY8.data.json";